// extracted by mini-css-extract-plugin
module.exports = {"Info":"Info_Info__3WoRg","Footer":"Info_Footer__2hxz3","GithubMark":"Info_GithubMark__2Bz8y"};